import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('usersettings.disdetta-offerta', {
            url: '/disdetta-offerta',
            views: {
                'userContent': {
                    templateUrl: './disdetta-offerta.html',
                    // template: '<disdetta-offerta></disdetta-offerta>'
                }
            },
            ncyBreadcrumb: {
                label: 'Disdetta Offerta',
                parent: 'usersettings.gestione-offerta'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Disdetta Offerta'
            }
        }
        );
};

stateConfig.$inject = ['$stateProvider'];

export const DisdettaOffertaModule: string = ng
    .module('archiSmall.userSettings.disdettaOffertaModule', [
        'ui.bootstrap',
        uiRouter,
        'ncy-angular-breadcrumb'
    ])
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/usersettings/disdetta-offerta/disdetta-offerta.module.ts